// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Q91sb","inner":"Footer_inner__1dhwn","nextIcon":"Footer_nextIcon__mDolm","innerLeft":"Footer_innerLeft__xvp1P"};